import { useImageStateStore } from 'stores/express-designer';

export function useUploadProgress() {
  const images = useImageStateStore(s => s.images);
  const uploading = images.filter(img => img.isUpload && img.totalBytes);

  const hasUploads = images.some(img => img.isUpload);

  if (!uploading.length) return { hasUploads, totalProgress: 0 };

  const total = uploading.reduce((sum, img) => sum + (img.totalBytes ?? 0), 0);
  const uploaded = uploading.reduce((sum, img) => sum + (img.uploadedBytes ?? 0), 0);

  return { hasUploads, totalProgress: total > 0 ? Math.round((uploaded / total) * 100) : 0 };
}
